/* Packages */
import { useEffect } from 'react';
import dotProp from 'dot-prop-immutable';

/* Hooks */
import useFlowContext from './useFlowContext';

export default function useValidation({
    register = () => { },
    unregister = () => { },
    formState = {},
    path,
    value,
    required,
    errors
}) {
    const {
        translate = () => { },
    } = useFlowContext();

    const error = dotProp.get(formState?.errors, path)?.message || errors?.[0];

    register(
        path,
        {
            value,
            required: {
                value: required,
                message: translate(`conversion_flow_bundle.flow.field.error.required`),
            },
        }
    );

    useEffect(() => {
        return () => {
            unregister(path);
        }
    }, []);

    return {
        error,
    }
}
